module.exports = __webpack_public_path__ + "static/fonts/fa-brands-400-ba7ed552362f64d30f6d844974d89114.svg";